import Vue from 'vue';
import global_mixin from './global_mixins.js'
import '../css/compare.css'

const app = new Vue({
  el: '#app',
  data () {
    return {
      
    }
  },
  created () {
    this.loadComparisons()
  },
  mixins: [global_mixin]
})


// WEBPACK FOOTER //
// ./core/vue/js/compare.js